/*
 * Jira Ticket:
 * Created Date: Tue, 29th Oct 2019, 12:06:33 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2019 The Distance
 */

import defaults from 'lodash.defaults';
import pickBy from 'lodash.pickby';
import identity from 'lodash.identity';

export const setTabbedFilterFieldReducer = (state = {}, action) => {
  switch (action.type) {
    case 'APP/SET_FILTER':
      const prevState = Object.assign({}, state[action.tab]);
      const combined = defaults(action.data, prevState); // merge our specific resource filters
      const cleaned = pickBy(combined, identity); // remove all falsey values
      return { ...state, [action.tab]: cleaned }; // return the new merged filters
    case 'APP/CLEAR_FILTERS':
      const removedTabFilter = Object.assign({}, state);
      delete removedTabFilter[action.tab];
      return { ...removedTabFilter };
    default:
      return state;
  }
};

export const multiLangReducer = (state, action) => {
  switch (action.type) {
    case 'setLanguages':
      return { ...state, languages: action.value };
    case 'setLanguage':
      return { ...state, language: action.value };
    case 'setLocalisations':
      return { ...state, localisations: action.value };
    case 'setCurrentRecord':
      return { ...state, currentRecord: action.value };
    default:
      throw new Error(
        `Unsupported action type in MultilanguageForm ${action.type}`
      );
  }
};
